import { render, staticRenderFns } from "./profiloUtente.vue?vue&type=template&id=7d1614f6"
import script from "./profiloUtente.vue?vue&type=script&lang=js"
export * from "./profiloUtente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports